import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../store/actions/AuthActions";
import { useTranslation } from "react-i18next";
import logoImg from "../../assets/logo.svg";
import Loader from "../../common/Loader";
import { toast } from "react-toastify";
import ProductsService from "../../services/ProductsService";
import CartService from "../../services/CartService";
import ProductCard from "../../Enums/ProductCard";
import { motion } from "framer-motion";
import "./style.css";

const Product = () => {
	const [product, setProduct] = useState({});
	const [similarProduct, setSimilarProduct] = useState([]);
	const [amount, setAmount] = useState(1);
	const [selectedImage, setSelectedImage] = useState("");
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [loader, setLoader] = useState(false);
	const [loading, setLoading] = useState(false);
	const [categoryId, setCategoryId] = useState(null);
	const lang = useSelector((state) => state?.lang?.lang);
	const user = useSelector((state) => state?.user);
	const productsService = new ProductsService();
	const cartService = new CartService();

	useEffect(() => {
		let id = location?.pathname?.split("/products/product/")[1];
		setLoading(true);
		productsService
			.getProdust(id)
			?.then((res) => {
				if (res?.status === 200) {
					setProduct(res?.data?.data?.product);
					setSelectedImage(res?.data?.data?.product.product_images[0]?.url);
					setCategoryId(res?.data?.data?.product?.category_id);
				}
				setLoading(false);
			})
			.catch((e) => setLoading(false));
	}, [location]);

	useEffect(() => {
		if (!!categoryId) {
			let params = {
				category_id: categoryId,
				offset: 0,
				limit: 15,
			};
			productsService?.getList(params).then((res) => {
				if (res?.status) {
					setSimilarProduct(
						res?.data?.data?.data?.filter((prod) => prod?.id !== product?.id)
					);
				}
			});
		}
	}, [categoryId]);

	const addCart = () => {
		let data = {
			products: [
				{
					amount: amount,
					product_id: product?.id,
				},
			],
		};
		setLoader(true);
		if (!!user?.user) {
			cartService
				.create(data)
				.then((res) => {
					if (res?.status === 201) {
						toast.success(t("Product Added To Cart"));
						dispatch(
							addToCart({
								...product,
								amount: amount,
							})
						);
					}
					setLoader(false);
				})
				.catch((e) => {
					setLoader(false);
					if (
						e.response?.data?.message ===
						"product_is_already_Exist_in_your_cart"
					) {
						let data = {
							product_id: product.id,
							amount: amount,
						};
						cartService.update(data).then((res) => {
							if (res?.status === 200) {
								toast.success(t("Product Added To Cart"));
							}
						});
						return;
					}
					toast.error(e.response?.data?.message?.replaceAll("_", " "));
				});
		} else {
			toast.success(t("Product Added To Cart"));
			dispatch(
				addToCart({
					...product,
					in_stock: product?.amount,
					amount: amount,
				})
			);
			setTimeout(() => setLoader(false), [500]);
		}
	};

	if (loading) {
		return (
			<div className="product">
				<Loader />
			</div>
		);
	}
	return (
		<>
			<div className="product">
				<div className="row">
					<div className="col-lg-5 col-md-12 col-12 text-center">
						<div className="main-img m-auto">
							<motion.img
								src={selectedImage || logoImg}
								alt="product"
								initial={{ opacity: 0, y: 50 }}
								animate={{ opacity: 1, y: 0 }}
								whileHover={{ scale: 1.1 }}
								whileTap={{ scale: 0.95 }}
								transition={{ duration: 1, type: "spring", stiffness: 200 }}
								className="w-100 h-100"
							/>
						</div>
						{!!product?.product_images?.filter(
							(res) => res?.url !== selectedImage
						)?.length && (
							<div className="px-5 mt-3">
								<Swiper
									slidesPerView={4}
									spaceBetween={5}
									pagination={{
										clickable: true,
									}}
									className="mySwiper mt-4 d-flex flex-column"
									style={{ direction: "ltr" }}
									modules={[Pagination]}>
									{product?.product_images
										?.filter((res) => res?.url !== selectedImage)
										?.map((img, index) => {
											return (
												<SwiperSlide style={{ height: "auto" }} key={index}>
													<img
														className="w-75 h-100"
														src={img?.url}
														alt={index}
														onClick={() => setSelectedImage(img?.url)}
													/>
												</SwiperSlide>
											);
										})}
								</Swiper>
							</div>
						)}
					</div>
					<div className="col-lg-7 col-md-12 col-12">
						<motion.h1
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ delay: 0.25, duration: 1 }}
							className="product-name">
							{lang === "en" ? product?.name_en : product?.name_ar}
						</motion.h1>
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ delay: 0.25, duration: 1 }}
							className="prices">
							{!product?.offer && (
								<p className="price">
									{product.price?.toFixed(3)} {t("KWD")}
								</p>
							)}
							{product?.offer && (
								<p className="price">
									{product.offerPrice?.toFixed(3)} {t("KWD")}
								</p>
							)}
							{product?.offer && (
								<p className="old-price">
									{product.price?.toFixed(3)} {t("KWD")}
								</p>
							)}
							{product.offer && (
								<p className="discount">
									-{(product.price - product.offerPrice)?.toFixed(3)} {t("KWD")}
								</p>
							)}
						</motion.div>
						{!!product.sub_category && (
							<span className="subCategory">
								{lang === "en"
									? product.sub_category?.name_en
									: product.sub_category?.name_ar}
							</span>
						)}
						<div className="description">
							<p>{t("Description")}:</p>
							<span>
								{lang === "en"
									? product.description_en
									: product.description_ar}
							</span>
						</div>

						<div className="d-flex gap-12">
							<div className="amounts" style={{ alignItems: "center" }}>
								<svg
									width="32"
									height="32"
									style={{
										cursor:
											product?.amount === amount ? "not-allowed" : "pointer",
									}}
									onClick={() => {
										if (product?.amount === amount) {
											return;
										}
										setAmount((prev) => ++prev);
									}}
									viewBox="0 0 32 32"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<rect width="32" height="32" rx="8" fill="white" />
									<path
										d="M10 16H22"
										stroke="#292D32"
										stroke-width="2.4"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M16 22V10"
										stroke="#292D32"
										stroke-width="2.4"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								<span>{amount}</span>
								<svg
									onClick={() => {
										if (amount === 1) {
											return;
										}
										setAmount((prev) => --prev);
									}}
									style={{
										cursor: amount === 1 ? "not-allowed" : "pointer",
									}}
									width="32"
									height="32"
									viewBox="0 0 32 32"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_221_10492)">
										<rect width="32" height="32" rx="8" fill="white" />
										<path
											d="M6.39941 16H25.5994"
											stroke="#292D32"
											stroke-width="2.4"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</g>
									<defs>
										<clipPath id="clip0_221_10492">
											<rect width="32" height="32" rx="8" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</div>
							{product?.amount > 0 && (
								<>
									{loader ? (
										<div
											className="d-flex justify-content-center"
											style={{ width: "167px" }}>
											<Loader />
										</div>
									) : (
										<button
											onClick={addCart}
											disabled={amount === 0}
											className={amount === 0 ? "buy disabled-buy" : "buy"}>
											{t("Add To Cart")}
										</button>
									)}
								</>
							)}
							{product?.amount === 0 && (
								<p className="text-danger mt-4">{t("out of stock")}</p>
							)}
						</div>
					</div>
				</div>
			</div>
			{!!similarProduct?.length && (
				<div className="similar_products">
					<div className="d-flex justify-content-between align-items-center">
						<h1>{t("Similar Products")}</h1>
						<Link to={`/category/${categoryId}`} className="shop-now">
							{t("Shop Now")}
						</Link>
					</div>
					<div>
						<Swiper
							slidesPerView={2}
							spaceBetween={20}
							pagination={{
								clickable: true,
							}}
							modules={[Pagination]}
							className="mySwiper similar-swiper"
							breakpoints={{
								640: {
									slidesPerView: 2,
									spaceBetween: 20,
								},
								768: {
									slidesPerView: 3,
									spaceBetween: 25,
								},
								1024: {
									slidesPerView: 4,
									spaceBetween: 30,
								},
							}}>
							{similarProduct?.map((item, index) => {
								return (
									<SwiperSlide
										key={index}
										onClick={() => navigate(`/products/product/${item?.id}`)}>
										<ProductCard product={item} hasAddToCart={true} />
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
				</div>
			)}
		</>
	);
};
export default Product;
